import { z } from 'zod';

import { userSchema } from './user';

export type Distributor = z.infer<typeof distributorSchema>;
export const distributorSchema = z.object({
  distributorId: z.number(),
  distributorName: z.string(),
  distributorUsers: z.array(userSchema),
});

export type CreateDistributorBody = z.infer<typeof createDistributorBodySchema>;
export const createDistributorBodySchema = z.object({
  distributorName: z.string().max(255),
});
